import { Component, Input, NgZone, ChangeDetectorRef, Renderer2, Inject, ViewEncapsulation } from '@angular/core';
import { TimeoutQueue } from '@common/services/timeout-queue';
import { AppService } from '@suite/app.service';
import { ModalResponseCodes, ModalService } from '../../modal/modal.service';
import { UserStaffInfo } from '@common/data-models/service/user-staff-info';
import { InvitationStatusCodes, GlobalRoles } from '@common/utils/util';
import { DataStore } from '@common/data-models/data-store/data-store';
import { UsersResults } from '@common/data-models/search-results/users-result';
import { GlobalTablesService } from '@common/services/global-tables-service';

import { NomWebServicesJson } from "@common/services/nom-web-services-json";
import { LanguageSettings } from "@common/services/language-settings";
import { TeamMembersService } from "@common/services/team-members-service";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserGroup } from '../../../data-models/search-results/result-group';
import { EnpsComponent } from '@common/components/base/enps-component';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'add-team-member',
    templateUrl: './add-team-member.html',
    styleUrls: ['./add-team-member.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        'class': 'st-add-team-member'
    }
})
export class AddTeamMember extends EnpsComponent {

    public newUser: UserStaffInfo = new UserStaffInfo();
    public newUserCurrentRole;
    public InvitationStatusCodes: any = InvitationStatusCodes;
    internalProgramFormControl: FormControl = new FormControl(null);
    internalRoleFormControl: FormControl = new FormControl(null);
    internalStatusFormControl: FormControl = new FormControl(null);

    constructor(
        public appService: AppService,
        private modalService: ModalService,
        ngZone: NgZone,
        public changeDetectorRef: ChangeDetectorRef,
        timeoutQueue: TimeoutQueue,
        public globalTablesService: GlobalTablesService,
        public nomWebServicesJson: NomWebServicesJson,
        public languageSettings: LanguageSettings,
        public teamMembersService: TeamMembersService,
        renderer: Renderer2,
        public dialogRef: MatDialogRef<AddTeamMember>,
        @Inject(MAT_DIALOG_DATA) public inputData: any,
    ) {
        super(timeoutQueue);
    }

    public get userGroups(): { [id: string]: UserGroup<UserStaffInfo> } {
        return DataStore.usersResults.usersGroups;
    }

    public get disabled(): boolean {
        let disabled: boolean = !this.newUser.UserID.trim() || !this.newUser.GivenName.trim() || !this.newUser.Surname.trim() || !this.newUser.Program.trim() || !this.newUser.Active || !this.newUserCurrentRole
        return disabled;
    }

    public get newUsers(): Array<UserStaffInfo> {
        return DataStore.usersResults.newUsers;
    }

    ngOnInit() {
        this.internalProgramFormControl.markAsTouched();
        this.internalRoleFormControl.markAsTouched();
        this.internalStatusFormControl.markAsTouched();
        this.changeDetectorRef.detectChanges();
    }

    public newUserSelectRole() {
        if (this.newUserCurrentRole) {
            if (this.newUserCurrentRole.ID == GlobalRoles.SUPERVISOR_ID) {
                this.newUser.Supervisor = true;
            } else {
                this.newUser.Supervisor = false;
                this.newUser.ServerManager = false;
                this.newUser.GlobalRole = this.newUserCurrentRole.ID;
            }
        } else {
            this.newUserCurrentRole = null;
        }
    }

    public async addUser() {
        if (!this.disabled) {
            this.loading = true;
            try {
                // Check if user already exists
                if (!DataStore.usersResults.checkUserExists(this.newUser.UserID)) {
                    this.newUser.UserID = this.newUser.UserID.trim();
                    this.newUser.GivenName = this.newUser.GivenName.trim();
                    this.newUser.Surname = this.newUser.Surname.trim();
                    this.newUser.Email = this.newUser.Email.trim();
                    this.newUser.SSOLogins = this.newUser.SSOLogins.trim();
                    this.newUser.Active = this.newUser.Active;
                    let res = await this.teamMembersService.createTeamMember(this.newUser);
                    if (res.status) {
                        let userToAdd = Object.assign(new UserStaffInfo, res.data);
                        DataStore.usersResults.addUser(userToAdd);
                        DataStore.usersResults.rebuildGroups(UsersResults.groupByField, UsersResults.sortByField);
                        this.newUser = new UserStaffInfo();
                        this.newUserCurrentRole = null;
                        this.newUser.Active = null;
                    }
                    this.dialogRef.close();
                } else {
                    this.modalService.openAlert("Add user", "User with ID \"" + this.newUser.UserID.toUpperCase() + "\" already exists!", "Ok");
                }
            } catch (e) {
                console.log(e)
            }

            setTimeout(() => {
                this.loading = false;
            }, 1000);
        }
    }

    public cancelNew() {
        this.dialogRef.close();
    }

    public onNewUserChanged(event: any, prop: string) {
        this.newUser[prop] = event
    }
}
